<script setup>
import { computed } from 'vue';
import { useCompetitorAppConfig } from 'src/composables/useCompetitorAppConfig';
import { useToggleable } from 'src/composables/useToggleable';

const props = defineProps({
  propertyType: {
    type: String,
    required: true,
  },
});

const { getTechnicalPropertyType } = useCompetitorAppConfig();

const propertyTypeConfig = computed(() => getTechnicalPropertyType(props.propertyType));

const hasDescription = computed(() => !!propertyTypeConfig.value?.description);

const { toggle, isOpen, close } = useToggleable();

function toggleDescription() {
  if (hasDescription.value) {
    toggle();
  }
}
</script>

<template>
  <div
    class="ce-technicalPropertyInfo"
    :class="{'ce-technicalPropertyInfo--hasDescription': hasDescription}"
    @click="toggleDescription">
    {{ propertyTypeConfig.title }}

    <Teleport to="body">
      <modal
        v-if="hasDescription && isOpen"
        :headline="propertyTypeConfig.title"
        @close="close">
        <div class="ce-modalContent">
          <div v-html="propertyTypeConfig.description" />
        </div>
      </modal>
    </Teleport>
  </div>
</template>

<style lang="less" scoped>
@import (reference) '~styles/includes/base';

.ce-technicalPropertyInfo {
  font-weight: bold;

  &.ce-technicalPropertyInfo--hasDescription {
    text-decoration: underline;
    .noselect();
    cursor: pointer;

    .ce-modal {
      font-weight: normal;
      line-height: 1.25;

      img {
        max-width: 100%;
      }
    }
  }
}
</style>
